export default {
  name: 'inv-strat-asset',
  props: {
    asset: {
      type: Object,
      required: true,
    },
    error: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    name: '',
    min: 0,
    max: 100,
    showErrorModal: false,
  }),
  computed: {
    rangeStyle() {
      return {
        left: `${this.min}%`,
        width: `${this.max - this.min}%`,
      };
    },
  },
  watch: {
    asset: {
      handler(val) {
        this.name = val.name;
        this.min = val.min;
        this.max = val.max;
      },
      immediate: true,
    },
    min(val) {
      this.$emit('min', val);
    },
    max(val) {
      this.$emit('max', val);
    },
  },
  methods: {
    handleDelete() {
      this.$emit('delete');
    },
    handleErrorClick() {
      this.showErrorModal = true;
    },
    handleClick(e) {
      if (e !== 'Other') {
        return;
      }
      this.$emit('showOtherAssetDialog');
    },
  },
};
